export enum CRAServiceErrorCode {
  GENERAL,
}

export enum CRAActions {
  New = 'new',
  ViewStatus = 'viewstatus',
  ViewData = 'viewdata',
  AddClient = 'addclient',
}

export interface CRAFailure {
  message: string
}

export interface CRARequestServerData {
  SDACRAIdent: number
}

export enum CRAStatus {
  ToDo = 1,
  InProgress = 2,
  Fail = 3,
  Success = 4,
}

export interface CRAStatusServerData {
  CreateTS: number
  Data: {
    ClientID: number
    CardNumber: string
    IDDocNo: string
    IDDocSerial: string
    BirthYear: number
    SubContractID: string
    CRARequestID: number
    CRAResponseID: number
    HashSum_CRARequestID_: string
  }
  Error: {
    Code: number
    Message: string
    Text: string
  }
  ExpireInPrTS: number
  ExpireNewTS: number
  ExpireSec: number
  ExpireTS: number
  Ident: string
  SEC_UserID: number
  StatusID: CRAStatus
}

export interface CRAProfileServerData {
  ClientID: number
  DOB: string
  Document_DocTypeID: number
  Document_DocTypeName: string
  Document_ID: number
  Document_IssueDate: string
  Document_IssuerName: string
  Document_Number: string
  Document_Serial: string
  Document_StatusId: number
  Document_StatusName: string
  Document_ValidDate: string
  Document_VoidDate: string
  ErrorCode: any
  ErrorMessage: string
  ID: number
  Number: string
  Person_BirthDate: string
  Person_BirthPlace: string
  Person_CitizenshipCountry: string
  Person_FirstName: string
  Person_GenderID: number | null
  Person_ID: number
  Person_LastName: string
  Person_PersonStatus: string
  Person_PersonStatusId: number
  Person_PrivateNumber: string
  Photo_Id: number
  Photo_PhotoImage: string
  PrivateNumber: string
  ProxyRef: string
  RDate: string
  RTypeID: number
  Registration_ActiveAddress: string
  Registration_ActiveAddressAddressID: number
  Registration_ActiveAddressAddressSource: string
  Registration_AddrStatus: string
  Registration_AddrStatusID: number
  Registration_OA_ID: number
  ResponseDate: string
  Response_Id: number
  Response_ReferenceId: string
  Response_TimeStamp: string
  ResultStatus_Code: number
  ResultStatus_Message: string
  SEC_UserID: number
  Serial: string
  SubContractID: string
}

export interface AddCRAClientServerData {
  ClientID: number
  HashSum_ClientID_: number
  // ...
}
